<template>
  <div id="app">
    <TopBar class="top-bar" />
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import TopBar from './components/TopBar.vue';

export default {
  name: 'App',
  components: {
    TopBar,
  },
};
</script>

<style>
body, html, #app {
  margin: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

#app {
  display: flex;
  flex-direction: column;
  height: 100%;
}


.tab-content {
  height: calc(100vh - 240px); /* 根据你的需求设置合适的高度 */
  overflow-y: auto; /* 允许垂直滚动 */
  margin-top: 10px;
}

.top-bar {
  position: fixed; /* 固定在页面顶部 */
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000; /* 确保在其他内容之上 */
  background-color: #ffffff;
  width: 100%;
  height: 50px; /* 确定TopBar高度 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}

.content {
  flex-grow: 1; /* 让内容区撑满剩余空间 */
  overflow-y: auto; /* 如果内容超出屏幕，则可以滚动 */
  padding-top: 50px; /* 设置与TopBar相同的高度，避免内容被遮挡 */
}

.file-path-hover {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl; /* 从右向左展示内容 */
  text-align: left; /* 保持内容左对齐 */
  transition: color 0.2s ease; /* 添加颜色渐变效果 */
}


.file-path-hover:hover {
  color: #6a94d6; /* 超链接悬停颜色 */
  //text-decoration: underline; /* 下划线效果 */
}
</style>
